import { Injectable } from "@angular/core";

const PHONETIC_ALPHABET_EN: Record<string, string> = {
  A: "Alfa",
  B: "Bravo",
  C: "Charlie",
  D: "Delta",
  E: "Echo",
  F: "Foxtrot",
  G: "Golf",
  H: "Hotel",
  I: "India",
  J: "Juliett",
  K: "Kilo",
  L: "Lima",
  M: "Mike",
  N: "November",
  O: "Oscar",
  P: "Papa",
  Q: "Quebec",
  R: "Romeo",
  S: "Sierra",
  T: "Tango",
  U: "Uniform",
  V: "Victor",
  W: "Whiskey",
  X: "Xray",
  Y: "Yankee",
  Z: "Zulu",
};

const PHONETIC_ALPHABET_IT: Record<string, string> = {
  A: "Ancona",
  B: "Bologna",
  C: "Como",
  D: "Domodossola",
  E: "Empoli",
  F: "Firenze",
  G: "Genova",
  H: "Hotel",
  I: "Imola",
  J: "Jolly",
  K: "Kursaal",
  L: "Livorno",
  M: "Milano",
  N: "Napoli",
  O: "Otranto",
  P: "Palermo",
  Q: "Quarto",
  R: "Roma",
  S: "Savona",
  T: "Torino",
  U: "Udine",
  V: "Venezia",
  W: "Washington",
  X: "Xeres",
  Y: "York",
  Z: "Zara",
};

const PHONETIC_ALPHABET_DE: Record<string, string> = {
  A: "Anton",
  B: "Berta",
  C: "Cäsar",
  D: "Dora",
  E: "Emil",
  F: "Friedrich",
  G: "Gustav",
  H: "Heinrich",
  I: "Ida",
  J: "Julius",
  K: "Kaufmann",
  L: "Ludwig",
  M: "Martha",
  N: "Nordpol",
  O: "Otto",
  P: "Paula",
  Q: "Quelle",
  R: "Richard",
  S: "Samuel",
  T: "Theodor",
  U: "Ulrich",
  V: "Viktor",
  W: "Wilhelm",
  X: "Xanthippe",
  Y: "Ypsilon",
  Z: "Zacharias",
};

const PHONETIC_ALPHABET_FR: Record<string, string> = {
  A: "Anatole",
  B: "Berthe",
  C: "Célestin",
  D: "Désiré",
  E: "Eugène",
  F: "François",
  G: "Gaston",
  H: "Henri",
  I: "Irma",
  J: "Joseph",
  K: "Kléber",
  L: "Louis",
  M: "Marcel",
  N: "Nicolas",
  O: "Oscar",
  P: "Pierre",
  Q: "Quintal",
  R: "Raoul",
  S: "Suzanne",
  T: "Thérèse",
  U: "Ursule",
  V: "Victor",
  W: "William",
  X: "Xavier",
  Y: "Yvonne",
  Z: "Zoé",
};

const PHONETIC_ALPHABET_ES: Record<string, string> = {
  A: "Antonio",
  B: "Barcelona",
  C: "Carmen",
  D: "Dolores",
  E: "Enrique",
  F: "Francia",
  G: "Granada",
  H: "Historia",
  I: "Inés",
  J: "José",
  K: "Kilo",
  L: "Lorenzo",
  M: "Madrid",
  N: "Navarra",
  O: "Oviedo",
  P: "París",
  Q: "Querido",
  R: "Ramón",
  S: "Sábado",
  T: "Tarragona",
  U: "Ulises",
  V: "Valencia",
  W: "Washington",
  X: "Xiquena",
  Y: "Yegua",
  Z: "Zaragoza",
};

const PHONETIC_ALPHABET_NL: Record<string, string> = {
  A: "Anton",
  B: "Bernard",
  C: "Cornelis",
  D: "Dirk",
  E: "Eduard",
  F: "Ferdinand",
  G: "Gerard",
  H: "Hendrik",
  I: "Izaak",
  J: "Jan",
  K: "Karel",
  L: "Lodewijk",
  M: "Maria",
  N: "Nico",
  O: "Otto",
  P: "Pieter",
  Q: "Quotiënt",
  R: "Richard",
  S: "Simon",
  T: "Theodoor",
  U: "Utrecht",
  V: "Victor",
  W: "Willem",
  X: "Xantippe",
  Y: "Ypsilon",
  Z: "Zacharias",
};

const PHONETIC_ALPHABET_PT: Record<string, string> = {
  A: "Aveiro",
  B: "Braga",
  C: "Coimbra",
  D: "Dafundo",
  E: "Évora",
  F: "Faro",
  G: "Guarda",
  H: "Horta",
  I: "Itália",
  J: "José",
  K: "Kodak",
  L: "Lisboa",
  M: "Maria",
  N: "Nazaré",
  O: "Ovar",
  P: "Porto",
  Q: "Queluz",
  R: "Rossio",
  S: "Setúbal",
  T: "Tavira",
  U: "Unidade",
  V: "Vidago",
  W: "Waldyr",
  X: "Xavier",
  Y: "York",
  Z: "Zulmira",
};

const PHONETIC_ALPHABET_PL: Record<string, string> = {
  A: "Adam",
  B: "Barbara",
  C: "Celina",
  D: "Dorota",
  E: "Ewa",
  F: "Franciszek",
  G: "Genowefa",
  H: "Henryk",
  I: "Irena",
  J: "Jan",
  K: "Karol",
  L: "Leon",
  M: "Maria",
  N: "Natalia",
  O: "Olga",
  P: "Paweł",
  Q: "Quebec",
  R: "Roman",
  S: "Stefan",
  T: "Tadeusz",
  U: "Urszula",
  V: "Viktor",
  W: "Wanda",
  X: "Xawery",
  Y: "Ypsilon",
  Z: "Zofia",
};

@Injectable({
  providedIn: "root",
})
export class TtsService {
  private synthesis: SpeechSynthesis | null = null;
  private utterance: SpeechSynthesisUtterance | null = null;
  private voices: SpeechSynthesisVoice[] = [];
  private waitTimeout: ReturnType<typeof setTimeout> | null = null;
  private countdownInterval: ReturnType<typeof setInterval> | null = null;
  private skipWaitCallback?: () => void;
  private countdownPaused = false;
  private pausedCountdownRemaining = 0;
  private pausedCountdownCallback?: (remaining: number) => void;
  private pausedResolveCallback?: () => void;
  private speakGeneration = 0;

  constructor() {
    if (typeof window !== "undefined" && "speechSynthesis" in window) {
      this.synthesis = window.speechSynthesis;
      this.loadVoices();

      if (this.synthesis.onvoiceschanged !== undefined) {
        this.synthesis.onvoiceschanged = () => this.loadVoices();
      }
    }
  }

  private loadVoices(): void {
    if (this.synthesis) {
      this.voices = this.synthesis.getVoices();
    }
  }

  private findBestVoice(language: string): SpeechSynthesisVoice | undefined {
    const langBase = language.split("-")[0];

    const matchingVoices = this.voices.filter(
      (v) => v.lang === language || v.lang.startsWith(`${langBase}-`),
    );

    if (matchingVoices.length === 0) {
      return undefined;
    }

    const qualityIndicators = [
      "enhanced",
      "premium",
      "natural",
      "neural",
      "online",
      "samantha",
      "alex",
      "daniel",
      "karen",
      "moira",
      "tessa",
      "fiona",
      "alice",
      "luca",
      "federica",
      "paola",
      "google",
      "microsoft",
    ];

    const scoredVoices = matchingVoices.map((voice) => {
      let score = 0;
      const nameLower = voice.name.toLowerCase();

      if (voice.lang === language) {
        score += 10;
      }

      for (const indicator of qualityIndicators) {
        if (nameLower.includes(indicator)) {
          score += 5;
        }
      }

      if (voice.localService) {
        score += 2;
      }

      const lowQualityIndicators = ["compact", "espeak", "mbrola"];
      for (const indicator of lowQualityIndicators) {
        if (nameLower.includes(indicator)) {
          score -= 10;
        }
      }

      return { voice, score };
    });

    scoredVoices.sort((a, b) => b.score - a.score);
    return scoredVoices[0]?.voice;
  }

  isSupported(): boolean {
    return this.synthesis !== null;
  }

  getPhoneticLetter(letter: string, language: string): string {
    if (!letter || letter === "_") return "empty";

    const langCode = language?.toLowerCase() || "en";
    let map = PHONETIC_ALPHABET_EN;

    if (langCode.startsWith("it")) {
      map = PHONETIC_ALPHABET_IT;
    } else if (langCode.startsWith("de")) {
      map = PHONETIC_ALPHABET_DE;
    } else if (langCode.startsWith("fr")) {
      map = PHONETIC_ALPHABET_FR;
    } else if (langCode.startsWith("es")) {
      map = PHONETIC_ALPHABET_ES;
    } else if (langCode.startsWith("nl")) {
      map = PHONETIC_ALPHABET_NL;
    } else if (langCode.startsWith("pt")) {
      map = PHONETIC_ALPHABET_PT;
    } else if (langCode.startsWith("pl")) {
      map = PHONETIC_ALPHABET_PL;
    }

    if (letter.length === 1 && map[letter.toUpperCase()]) {
      return map[letter.toUpperCase()];
    }
    return letter;
  }

  async speak(
    text: string,
    rate: number = 1.0,
    language?: string,
    onEnd?: () => void,
    onError?: () => void,
    pauseAfterSpeech: number = 0,
    onCountdownUpdate?: (remaining: number) => void,
  ): Promise<void> {
    if (!this.synthesis) return;

    this.stop();
    const myGeneration = this.speakGeneration;

    try {
      const match = text.match(/^(\d+)\s+(.+)$/);
      if (match) {
        const number = match[1];
        const word = match[2];

        await this.speakPartAsync(number, rate, language);
        if (this.speakGeneration !== myGeneration) return;

        await this.delay(200);
        if (this.speakGeneration !== myGeneration) return;

        await this.speakPartAsync(word, rate, language);
        if (this.speakGeneration !== myGeneration) return;

        if (pauseAfterSpeech > 0) {
          await this.waitWithCountdownAsync(pauseAfterSpeech, onCountdownUpdate);
          if (this.speakGeneration !== myGeneration) return;
        }
      } else {
        await this.speakPartAsync(text, rate, language);
        if (this.speakGeneration !== myGeneration) return;

        if (pauseAfterSpeech > 0) {
          await this.waitWithCountdownAsync(pauseAfterSpeech, onCountdownUpdate);
          if (this.speakGeneration !== myGeneration) return;
        }
      }

      if (onCountdownUpdate) {
        onCountdownUpdate(0);
      }
      if (onEnd) {
        onEnd();
      }
    } catch (error) {
      if (onError) onError();
    }
  }

  pause(): void {
    if (this.synthesis) {
      this.synthesis.pause();
    }
  }

  resume(): void {
    if (this.synthesis) {
      this.synthesis.resume();
    }
  }

  stop(): void {
    this.speakGeneration++;
    if (this.synthesis) {
      this.synthesis.cancel();
    }
    this.utterance = null;
    this.clearWaitTimers();
  }

  skipWait(): void {
    if (this.skipWaitCallback) {
      const callback = this.skipWaitCallback;
      this.clearWaitTimers();
      callback();
    }
  }

  pauseCountdown(): void {
    if (this.waitTimeout && this.countdownInterval) {
      this.countdownPaused = true;
      this.clearWaitTimers();
    }
  }

  resumeCountdown(): void {
    if (this.countdownPaused && this.pausedCountdownRemaining > 0) {
      this.countdownPaused = false;
      const originalCallback = this.pausedCountdownCallback;
      const originalResolve = this.pausedResolveCallback;

      if (originalCallback && originalResolve) {
        this.waitWithCountdownAsync(
          this.pausedCountdownRemaining,
          originalCallback,
        ).then(() => {
          originalResolve();
        });
      }
    }
  }

  isPaused(): boolean {
    return this.synthesis?.paused || false;
  }

  isSpeaking(): boolean {
    return this.synthesis?.speaking || false;
  }

  private delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  private speakPartAsync(
    text: string,
    rate: number = 1.0,
    language?: string,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.synthesis) {
        reject(new Error("Speech synthesis not supported"));
        return;
      }

      this.utterance = new SpeechSynthesisUtterance(text);
      this.utterance.rate = rate;

      if (language) {
        this.utterance.lang = language;

        const hasVoiceForLanguage = this.voices.some(
          (v) => v.lang === language || v.lang.startsWith(language.split("-")[0]),
        );

        if (!hasVoiceForLanguage && this.voices.length > 0) {
          this.loadVoices();
        }

        const voice = this.findBestVoice(language);
        if (voice) {
          this.utterance.voice = voice;
        }
      }

      this.utterance.onend = () => resolve();
      this.utterance.onerror = (event) => {
        if (event.error === "canceled" || event.error === "interrupted") {
          resolve();
          return;
        }
        reject(event);
      };

      this.synthesis.speak(this.utterance);
    });
  }

  private waitWithCountdownAsync(
    duration: number,
    onCountdownUpdate?: (remaining: number) => void,
  ): Promise<void> {
    return new Promise((resolve) => {
      const startTime = Date.now();
      const endTime = startTime + duration;

      this.skipWaitCallback = resolve;
      this.pausedCountdownCallback = onCountdownUpdate;
      this.pausedResolveCallback = resolve;
      this.countdownPaused = false;

      this.countdownInterval = setInterval(() => {
        const remaining = Math.max(0, endTime - Date.now());
        this.pausedCountdownRemaining = remaining;
        if (onCountdownUpdate) {
          onCountdownUpdate(remaining);
        }
      }, 50);

      this.waitTimeout = setTimeout(() => {
        this.clearWaitTimers();
        this.pausedCountdownRemaining = 0;
        resolve();
      }, duration);
    });
  }

  private clearWaitTimers(): void {
    if (this.waitTimeout) {
      clearTimeout(this.waitTimeout);
      this.waitTimeout = null;
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    if (!this.countdownPaused) {
      this.skipWaitCallback = undefined;
      this.pausedCountdownCallback = undefined;
      this.pausedResolveCallback = undefined;
    }
  }
}
